/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import DialogButton from '../../utils/DialogButton';
import { ConnectionIcon } from './ConnectionIcon';

export function LearnMoreDialog({ open, onClose, name, logo, about, useCases }) {
	return (
		<Dialog open={open}>
			<DialogTitle>
				<Box sx={{ display: 'grid', gridGap: '8px', gridTemplateColumns: '24px 1fr' }}>
					<ConnectionIcon src={logo} />
					<div>
						<FormattedMessage
							id="LearnMoreDialog.Title"
							defaultMessage="Learn More about {type}"
							values={{ type: name }}
						/>
					</div>
				</Box>
			</DialogTitle>
			<DialogContent>
				{about ? (
					<React.Fragment>
						<Typography color="text.primary" variant="h6" sx={{ mt: 2 }}>
							<FormattedMessage id="LearnMoreDialog.About" defaultMessage="About" />
						</Typography>
						<DialogContentText dangerouslySetInnerHTML={{ __html: about }} />
					</React.Fragment>
				) : null}
				{useCases ? (
					<React.Fragment>
						<Typography color="text.primary" variant="h6" sx={{ mt: 2 }}>
							<FormattedMessage id="LearnMoreDialog.UseCases" defaultMessage="Use Cases" />
						</Typography>
						<DialogContentText dangerouslySetInnerHTML={{ __html: useCases }} />
					</React.Fragment>
				) : null}
			</DialogContent>

			<DialogActions>
				<DialogButton onClick={onClose}>
					<FormattedMessage id="Close" defaultMessage="Close" />
				</DialogButton>
			</DialogActions>
		</Dialog>
	);
}
